import { useSubscriptionsApi } from '@pages/billing/subscriptions'

import { defineNuxtRouteMiddleware } from '#app'

export default defineNuxtRouteMiddleware( () => {
  void useSubscriptionsApi({ background: true })
})
